<template>
  <b-row class="match-height m-2">
    <b-col
      cols="12"
    >
      <b-form>
        <b-row>
          <b-col cols="3">
            <b-form-group>
              <v-select
                id="trainingSystemId"
                v-model="filter.trainingSystemId"
                :options="trainingSystems"
                :reduce="option => option.value"
                placeholder="Hệ đào tạo"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group>
              <v-select
                id="yearId"
                v-model="filter.yearId"
                label="name"
                :options="years"
                :reduce="option => option.id"
                placeholder="Năm học"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group>
              <v-select
                id="semesterId"
                v-model="filter.semesterId"
                :options="semesters"
                :reduce="option => option.value"
                placeholder="Học kỳ"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
    <b-col
      v-if="filterFake.show && creatableOverview"
      lg="6"
      cols="12"
    >
      <students-card-chart
        :title="'Tổng quát Sinh viên'"
        :filter="filterFake"
      />
    </b-col>
    <b-col
      v-if="filterFake.show && creatableOverview"
      lg="6"
      cols="12"
    >
      <employees-card-chart
        :title="'Tổng quát Cán bộ/Giảng viên'"
        :filter="filterFake"
      />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable1"
      cols="6"
    >
      <employees-by-department-bar-chart :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable2"
      cols="6"
    >
      <classes-by-courses-and-department-bar-chart :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable3"
      cols="6"
    >
      <student-by-major-and-courses-line-area-chart :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable5"
      cols="6"
    >
      <k-l-t-n-by-department-echart-bar :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable6"
      cols="6"
    >
      <scores-by-subject-polar-area-chart :filter="filterFake" />
    </b-col>
    <!--    <b-col cols="6" v-if="filterFake.show && creatable7">-->
    <!--      <student-by-item-apex-chart :filter="filterFake" />-->
    <!--    </b-col>-->
    <b-col
      v-if="filterFake.show && creatable7"
      cols="6"
    >
      <student-award-by-item-bar-chart-horizontal :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable7"
      cols="6"
    >
      <student-t-c-s-p-by-item-bar-chart-horizontal :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable9"
      cols="6"
    >
      <student-suspend-horizontal-bar-chart :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable11"
      cols="6"
    >
      <student-scholarship-horizontal-bar-chart :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable4"
      cols="6"
    >
      <lectures-and-credit-class-echart-bar :filter="filterFake" />
    </b-col>
    <b-col
      v-if="filterFake.show && creatable12"
      cols="12"
    >
      <scores-by-credit-class-apex-chart :filter="filterFake" />
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { SEMESTER_NAME } from '@/const/status'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import StudentByMajorAndCoursesLineAreaChart
from '@/views/admin/category/charts/StudentByMajorAndCoursesLineAreaChart.vue'
import EmployeesByDepartmentBarChart from '@/views/admin/category/charts/EmployeesByDepartmentBarChart.vue'
import LecturesAndCreditClassEchartBar from '@/views/admin/category/charts/LecturesAndCreditClassEchartBar.vue'
import ScoresBySubjectPolarAreaChart from '@/views/admin/category/charts/ScoresBySubjectPolarAreaChart.vue'
import KLTNByDepartmentEchartBar from '@/views/admin/category/charts/KLTNByDepartmentEchartBar.vue'
import StudentSuspendHorizontalBarChart from '@/views/admin/category/charts/StudentSuspendHorizontalBarChart.vue'
import ScoresByCreditClassApexChart from '@/views/admin/category/charts/ScoresByCreditClassApexChart.vue'
import ClassesByCoursesAndDepartmentBarChart
from '@/views/admin/category/charts/ClassesByCoursesAndDepartmentBarChart.vue'
import StudentScholarshipHorizontalBarChart
from '@/views/admin/category/charts/StudentScholarshipHorizontalBarChart.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import StudentsCardChart from '@/views/admin/category/charts/StudentsCardChart.vue'
import EmployeesCardChart from '@/views/admin/category/charts/EmployeesCardChart.vue'
import StudentAwardByItemBarChartHorizontal from '@/views/admin/category/charts/StudentAwardByItemBarChartHorizontal.vue'
import StudentTCSPByItemBarChartHorizontal from '@/views/admin/category/charts/StudentTCSPByItemBarChartHorizontal.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    StudentAwardByItemBarChartHorizontal,
    StudentTCSPByItemBarChartHorizontal,
    EmployeesCardChart,
    StudentsCardChart,
    StudentScholarshipHorizontalBarChart,
    ClassesByCoursesAndDepartmentBarChart,
    ScoresByCreditClassApexChart,
    StudentSuspendHorizontalBarChart,
    KLTNByDepartmentEchartBar,
    ScoresBySubjectPolarAreaChart,
    LecturesAndCreditClassEchartBar,
    EmployeesByDepartmentBarChart,
    StudentByMajorAndCoursesLineAreaChart,
    BForm,
    BFormGroup,
    vSelect,
    BRow,
    BCol,
  },
  data() {
    return {
      user: getUser(),
      semesters: [],
      filter: {
        organizationId: null,
        trainingSystemId: null,
        yearId: null,
        semesterId: null,
      },
      filterFake: {},
    }
  },
  computed: {
    ...mapGetters({
      trainingSystems: 'dropdown/trainingSystems',
      years: 'reviewBoard/years',
    }),
    creatableOverview() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_STUDENTS_OVERVIEW, ResourceCode.CHART_EMPLOYEES_OVERVIEW)
    },
    creatable1() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_EMPLOYEES_BY_DEPARTMENT)
    },
    creatable2() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_CLASS_BY_COURSES_AND_DEPARTMENT)
    },
    creatable3() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_STUDENT_BY_MAJOR_AND_COURSES)
    },
    creatable4() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_TEACHER_AND_CREDIT_CLASS_BY_DEPARTMENT)
    },
    creatable5() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_STUDENT_BY_SUBJECT_TYPE)
    },
    creatable6() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_POINT_BY_SUBJECT)
    },
    creatable7() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_STUDENT_BY_ITEM)
    },
    creatable9() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_SUSPEND_STUDENT)
    },
    creatable11() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_STUDENT_SCHOLARSHIP_BY_DEPARTMENT)
    },
    creatable12() {
      return this.isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.CHART_SCORE_BY_CREDIT_CLASS)
    },
  },
  async created() {
    await this.getDataFromStore()
  },
  methods: {
    ...mapActions({
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getYears: 'reviewBoard/getYears',
    }),
    isSystemAdmin,
    async getDataFromStore() {
      this.isLoading = true
      this.semesters = SEMESTER_NAME
      try {
        await Promise.all([
          this.getTrainingSystems(),
          this.getYears(),
        ])
        this.filter.organizationId = this.user.orgId
        this.filter.trainingSystemId = 1
        this.filter.semesterId = 2
        if (this.years != null) {
          const currentYear = new Date().getFullYear() - 1
          const nextYear = currentYear + 1
          const checkYear = `${currentYear}-${nextYear}`
          const foundYear = this.years.find(year => year.name === checkYear)
          if (foundYear) {
            this.filter.yearId = foundYear.id
          }
        }
        const currentMonth = new Date().getMonth()
        if (currentMonth < 8) {
          this.filter.semesterId = 1
        }
        if (currentMonth >= 8 && currentMonth <= 12) {
          this.filter.semesterId = 2
        }
        this.filterFake = this.filter
        this.filterFake.show = true
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}

</script>
